import React from 'react';
import styled from 'styled-components';
import {Box, Container, Grid} from '@tenancy.nz/design-system';
import client1 from '../assets/iron-bridge.png';
import client2 from '../assets/lj-hooker.png';
import client3 from '../assets/ray-white.jpeg';
import client4 from '../assets/pukeko-rental.png';
import client5 from '../assets/first-national.png';
import client6 from '../assets/property-scouts.jpeg';
import client8 from '../assets/harcourts.png';

const StlyedImg = styled.img`
  max-width: 70%;
  transition: all 0.4s ease-in-out;
  display: inline-block;
  padding: 15px 0;
  -webkit-filter: grayscale(100);
  filter: grayscale(100);
  height: auto;
  transform: scale(1);

  &:hover {
    filter: none;
    transform: scale(1.1);
  }
`;

function ClientList() {
  return (
    <Box bgcolor="#fafafa" py={6}>
      <Container fixed>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client1} alt="Iron Bridge" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client2} alt="LJ Hooker" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client3} alt="RayWhite" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client4} alt="Pukeko Rental Managers" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client5} alt="First National" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client6} alt="Property Scouts" />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <StlyedImg src={client8} alt="Harcourts" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ClientList;
